export const Logo = ({ w = 40, h = 34 }) => (
  <img src="/logo-mark.png" width={w} height={h} alt="VeriAuth logo"
    style={{ objectFit: "contain", display: "block" }} />
);

export const Wordmark = ({ size = 18 }) => (
  <span className="name" style={{ fontSize: size }}>veri<span className="g">Auth</span><span className="d">.ai</span></span>
);
